import isEqual from 'lodash/isEqual'
import React, { FC, useCallback, useContext, useEffect, useRef } from 'react'

import { ImageV2 } from '@Components/Image'
import { ControllerContext } from '@Components/Product/Slider/Context/ControllerContext'
import { SliderContext } from '@Components/Product/Slider/Context/SliderContext'
import useImageControl from '@Components/Product/Slider/gestures/useImageControl'
import { Asset } from '@Generated/graphql'

export const ImageHorizontal: FC<{ asset?: Asset, index: number, title: string }> = ({
  asset,
  index,
  title,
}) => {
  const imageRef = useRef<HTMLDivElement>(null)
  const imageContainerRef = useRef<HTMLDivElement>(null)
  const {
    activeSlide,
    isFullscreen,
  } = useContext(SliderContext)
  const {
    controlState,
    setAnimate,
  } = useImageControl(imageRef, imageContainerRef)
  const { setZoomedIn } = useContext(ControllerContext)

  const updateAnimation = useCallback(() => {
    if (imageRef.current && activeSlide.key === index) {
      imageRef.current.style.transform
        = `scale3d(${controlState.scale},${controlState.scale},${controlState.scale}) translate(${controlState.x}px, ${controlState.y}px)`
      setAnimate(false)
    }
  }, [activeSlide.key, controlState, index, setAnimate])

  useEffect(() => {
    updateAnimation()
  }, [controlState, updateAnimation])

  if (!asset?.url) {
    return null
  }
  const sizes = isFullscreen ? '(min-width: 0px) 100vw' : '(min-width: 0px) 535px, (min-width: 900px) 445px, (min-width: 1024px) 590px, 590px'
  const touchAction = isFullscreen ? 'none' : 'pan-y'

  return (
    <div
      onClick={(e) => {
        if (isFullscreen && isEqual((e.target as HTMLDivElement).localName, 'div')) {
          e.stopPropagation()
          setZoomedIn(false)
        }
      }}
      ref={imageContainerRef}
      style={{
        position: 'relative',
        width: 'inherit',
        height: 'inherit',
        padding: activeSlide.key === index ? '0px' : '1px',
      }}
    >
      <div
        ref={imageRef}
        style={{
          width: 'auto',
          height: '100%',
          position: 'relative',
          transition: 'all 0.2s ease',
          background: '#F1EDE8',
          touchAction,
        }}
      >
        <ImageV2
          alt={`${title || ''} - ${index + 1}`}
          cropRatio={asset.tags?.includes('look') ? '1:1' : undefined}
          draggable={false}
          layout="fill"
          loading={index === 0 ? 'eager' : 'lazy'}
          objectFit="contain"
          objectPosition="center center"
          priority={index === 0}
          sizes={sizes}
          src={asset.url}
          style={{
            touchAction,
            mixBlendMode: 'multiply',
          }}
        />
      </div>
    </div>
  )
}
